
import { Component, Prop, Vue } from "vue-property-decorator";
import { mdiTrashCan } from "@mdi/js";
import { TranslateResult } from "vue-i18n";
import ResponsiveBtn from "@/components/generic/buttons/responsive-btn.vue";

@Component({
  components: { ResponsiveBtn },
})
export default class DeleteBtn extends Vue {

  @Prop({default: ""})
  public label: string|TranslateResult;

  @Prop({default: false})
  public disabled: boolean;

  private icons = {
    mdiTrashCan,
  };

  get defaultLabel(): TranslateResult {
    return this.$t("actions.delete");
  }
}
